import LoadingContent from "../../public/LoadingContent.js";
import React, {useEffect, useState} from "react";
import SidebarNav from "../Sidebar/SidebarNav.js";
import customMenuService from "../../../services/customMenuService.js";
import ModalCustomMenu from "./ModalCustomMenu.js";

const CustomMenus = () => {

    const titleSingular = 'Menú Personalizado';
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [isModalOpen, setModalOpen] = useState(false);
    const [editingModal, setEditingModal] = useState(null);

    const loadingContent = () => {
        customMenuService.getCustomMenu().then(data => {
            setData(data);
            setLoading(false);
        });
    }

    const handleCreate = () => {
        setEditingModal(null);
        setModalOpen(true);
    };

    const handleEdit = (data) => {
        setEditingModal(data);
        setModalOpen(true);
    };

    const handleDelete = async (itemId) => {
        if (window.confirm("¿Estás seguro que deseas borrar este menú?")) {
            try {
                await customMenuService.deleteCustomMenu(itemId);
                loadingContent();
            } catch (error) {
                console.error("Error deleting client:", error);
            }
        }
    }

    useEffect(() => {
        loadingContent();
    },[]);

    return (
        <div className="container-fluid" style={{background: 'url(/waves-white.png)'}}>
            <div className="row vh-100">

                <SidebarNav/>

                {isModalOpen && (
                    <ModalCustomMenu
                        editingModal={editingModal}
                        titleSingular={titleSingular}
                        isModalOpen={isModalOpen}
                        onClose={() => {
                            setModalOpen(false);
                            loadingContent();
                        }}
                    />
                )}

                <div className="p-4 content-container col-md-9 col-lg-10">

                    {loading && (
                        <LoadingContent/>
                    )}

                    {!loading && (
                        <div>
                            <h3 className="mb-4"><i className="bi bi-menu-button-fill"></i> Menús Personalizados</h3>
                            <button className="btn btn-primary mb-3" onClick={handleCreate}>
                                Crear Menú Personalizado
                            </button>

                            <table className="table table-striped corner-radius">
                                <thead>
                                <tr>
                                    <th>Nombre</th>
                                    <th>URL</th>
                                    <th>Ubicación</th>
                                    <th>Icono</th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                {Array.isArray(data) && data.map((item) => (
                                    <tr key={item.id}>
                                        <td>{item.name}</td>
                                        <td><a href={item.url}>{item.url}</a></td>
                                        <td>{item.location}</td>
                                        <td><i className={`bi ${item.icon}`}></i></td>
                                        <td>
                                            <div className="btn-group" role="group">
                                                <button
                                                    className="btn btn-warning btn-sm"
                                                    onClick={() => handleEdit(item)}>
                                                    Editar
                                                </button>
                                                <button
                                                    className="btn btn-danger btn-sm"
                                                    onClick={() => handleDelete(item.id)}>
                                                    Borrar
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>

                        </div>
                    )}

                </div>
            </div>
        </div>
    )
}

export default CustomMenus;